'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.actions = void 0;
var tslib_1 = require('tslib');
var immutable_1 = require('immutable');
var createActions_1 = require('./utils/createActions');
var CONSTANTS = {
    ADD_OR_UPDATE_OPERATION: '@sagun/ADD_OR_UPDATE_OPERATION',
    REMOVE_OPERATION: '@sagun/REMOVE_OPERATION',
};
var addOrUpdateOperation = (0, createActions_1.createAction)(
    CONSTANTS.ADD_OR_UPDATE_OPERATION,
    function (operationPatch) {
        return operationPatch;
    }
);
var removeOperation = (0, createActions_1.createAction)(CONSTANTS.REMOVE_OPERATION, function (operationId) {
    return operationId;
});
exports.actions = {
    addOrUpdateOperation: addOrUpdateOperation,
    removeOperation: removeOperation,
};
var INITIAL_STATE = (0, immutable_1.Map)();
function asyncOperationsReducer(state, action) {
    if (state === void 0) {
        state = INITIAL_STATE;
    }
    if (!immutable_1.Map.isMap(state)) {
        return Object.entries(state).reduce(function (map, item) {
            return map.set(item[0], item[1]);
        }, (0, immutable_1.Map)());
    }
    if (action.type === CONSTANTS.ADD_OR_UPDATE_OPERATION && action.payload) {
        var id = action.payload.id;
        if (state.has(id)) {
            return state.update(id, function (v) {
                return v ? (0, tslib_1.__assign)((0, tslib_1.__assign)({}, v), action.payload) : v;
            });
        }
        return state.set(id, action.payload);
    }
    if (action.type === CONSTANTS.REMOVE_OPERATION && action.payload) {
        var id = action.payload;
        if (state.has(id)) {
            return state.delete(id);
        }
        return state;
    }
    return state;
}
exports.default = asyncOperationsReducer;
